import {
  INTRUSION_PARTITION_STATUSES,
  INTRUSION_ZONE_STATUSES,
  INTRUSION_PARTITION_STATE_MATCHERS,
  INTRUSION_PARTITION_TRANSITION_MATCHERS,
  INTRUSION_ZONE_STATE_MATCHERS
} from '@/models/intrusion/constants';

export {
  INTRUSION_PARTITION_STATUSES,
  INTRUSION_ZONE_STATUSES,
  INTRUSION_PARTITION_STATE_MATCHERS,
  INTRUSION_PARTITION_TRANSITION_MATCHERS,
  INTRUSION_ZONE_STATE_MATCHERS
};

/** Fallback name for a panel/place/gateway with no assigned device. */
// TODO - this is only necessary until sc-47096 is implemented
export const INTRUSION_OUT_OF_SCOPE = 'Out of scope';

/** Local-storage key for the intrusion list display state (card/table toggle, sort, etc.). */
export const INTRUSION_LIST_KEY = 'intrusion-listing';

/** Local-storage key for the intrusion partition list display state (card/table toggle, sort, etc.). */
export const INTRUSION_PARTITION_LIST_KEY = 'intrusion-partition-listing';

/** Local-storage key for the zone list display state (card/table toggle, sort, etc.). */
export const ZONE_LIST_KEY = 'intrusion-zone-listing';

/** Card footer count abbreviations: (P)artitions / (Z)ones. */
export const PARTITION_COUNT_ABBR = 'P';
export const ZONE_COUNT_ABBR = 'Z';

export const INTRUSION_BANNER_STAT_IDS = {
  STATUS: 'status',
  PARTITION_COUNT: 'partition-count',
  ZONE_COUNT: 'zone-count'
} as const;

export const INTRUSION_BANNER_STAT_LABELS = {
  STATUS: 'Status',
  PARTITIONS: 'Partitions',
  ZONES: 'Zones'
} as const;

export const INTRUSION_STATE_GROUP = {
  ID_SUFFIX: 'states',
  TITLE: 'Partitions & Zones'
} as const;
